import React, { useEffect, useState } from 'react';
import { useTasksContext } from '../../providers/TasksContextProvider';
import Taska from '../avoda/Taska';
import Tikia from './Tikia';
import { useTaskListenerContext } from '../avoda/TaskListenerContextProvider';
import TagDisplay from '../avoda/TagDisplay';
import './ColorFolder.css';

export const devStage = [
  { id:100, c: '#150316', t: 'Next Release',     p:0 },
  { id:110, c: '#4a0d50', t: 'Later',            p:3 },
  { id:120, c: '#600668', t: 'Now',              p:5 },
  { id:130, c: '#311a07', t: 'Research',         p:15 },
  { id:140, c: '#6e3e16', t: 'New Branch',       p:18 },
  { id:150, c: '#b46d32', t: 'Design',           p:25 },
  { id:160, c: '#5f1205', t: 'Dev High Level',   p:33 },
  { id:170, c: '#992f1d', t: 'Dev Core' ,        p:50 },
  { id:180, c: '#e26953', t: 'Dev Edges' ,       p:66 },
  { id:190, c: '#052908', t: 'Test HappyFlow' ,  p:70 },
  { id:200, c: '#007c0a', t: 'Test Full' ,       p:80 },
  { id:210, c: '#106359', t: 'Commit Review' ,   p:85 },
  { id:220, c: '#56ddb2', t: 'Merge' ,           p:90 },
  { id:230, c: '#0082ad', t: 'Staging' ,         p:95 },
  { id:240, c: '#1966b4', t: 'Deployment' ,      p:98 },
  { id:250, c: '#0080ff', t: 'Production' ,      p:100}
];

//------[  PREV Stage  ]------
//
export const getPrevStage = (stageId) => {
  const ix = devStage.findIndex(stage => stage.id == stageId); // == ignore type to compare string value or number
  
  // Unknown StageId
  if (ix === -1) {
    console.error('Unknown StageId: %s', stageId);
    return devStage[0];
  }

  // Prev Id, otherwise stay with the First. 
  return ix > 0 ? devStage[ix -1] : devStage[0];
}

//------[  NEXT Stage  ]------
//
export const getNextStage = (stageId) => {
  const ix = devStage.findIndex(stage => stage.id == stageId);

  // Unknown StageId
  if (ix === -1) {
    console.error('Unknown StageId: %s', stageId);
    return devStage[0];
  }

  return ix < devStage.length - 1 ? devStage[ix + 1] : devStage[devStage.length - 1];
}

//    ------------ ColorFolder ------------
//
const ColorFolder = ({filterTags, filterPrios}) => {
  
  // TODO: Add tags to the tasks context, so everyone knows what are the current available tags (without the need to re-calcualte them each time)
  //       For example, when a task is deleted, the tags should be recalculated, and then listeners like the "selectedTag" can update themselves to switch to "All" if necessary.
  const {tasks}                 = useTasksContext(); 

  const {tasksChanged}          = useTaskListenerContext();
  const [show3d, setShow3d]     = useState(false);
  const [compList, setCompList] = useState([]);

  useEffect(()=>{
    const list = [...tasks]
        .map(t => (t.priority === "0" || !t.priority) ? {...t, priority: 4} : t)
        .map(t => ({...t, priority: Number(t.priority)}))
        .sort((a,b) => a.priority !== b.priority ? a.priority - b.priority : a.title > b.title ? 1 : a.title < b.title ? -1 : 0)
      
        .filter(task => {
          const tagMatch = Object.entries(filterTags)
            .filter(([prio, _]) => prio !== '0') // Exclude the '0' tag which is not a real tag
            .filter(([_, {isSelected}]) => isSelected)
            .every(([tag]) => task.tags?.includes(tag) || !tag); // Check if every selected tag exists in the task's tags
          
          return tagMatch;
          
        })
        // Add Filter by Priority
        .filter(task => {
          if (!filterPrios) return true; // No filterPrios means show all tasks

          const selectedCount = Object.entries(filterPrios)
            .filter(([_, {isSelected}]) => isSelected);

          if (selectedCount.length === 0) return true; // No selected priorities means show all tasks

          const prioMatch = Object.entries(filterPrios)
            .filter(([_, {isSelected}]) => isSelected)
            .some(([prio]) => task.priority == prio || !prio || prio == 0); // Check if any selected priority matches the task's priority
          
          return prioMatch;
        })
        
        // Add Filter by Stage 



        .map(t => <div className='taskRow' key={`delwrap_${t.taskId}`}>
      <Taska key={t.taskId} taskData={t}/>
    </div>);
      
    setCompList(list);
  }, [tasksChanged, tasks, filterTags, filterPrios]);

  // TODO: Name by Selected Tags?
  // const cap = tag ? tag.length > 2 ? 'capitalize' : 'uppercase' : 'capitalize';
  const activeTagNames = Object.entries(filterTags)
    .filter(([_, {isSelected}]) => isSelected)
    .map(([tag]) => <TagDisplay key={tag} tagName={tag} />);

  return (
    <div className='colorFolder'>      
        <div className='colorFolderTitle'>
          {activeTagNames.length > 0 ? activeTagNames : 'All '}Tasks
        </div>
        
        <div className='colorFolderTasks'>
          {compList}
        </div>

        {
        show3d && 
          <div className='colorFolder3DTikia'>
            <Tikia tasks={tasks} tikiName='MyWork' whenTaskUpdated={() => {}} key='tikiaMyWork' />
          </div>
        }
    </div>
  );
};

export default ColorFolder;